export default class ConfirmMultiple {
  act(tasks, vue, callback) {
    tasks = tasks.filter(task => task.done === 1)

    if (!tasks.length) {
      callback()
      return
    }

    const data = {
      task_id: tasks.map(task => task.id)
    }

    vue.axios.post('/tasks/bill', data)
      .then(res => {
        const tasks = res.data.data
        tasks.forEach(task => vue.$root.$emit('taskBilled', task))
        callback()
      })
  }
}



// WEBPACK FOOTER //
// ./src/views/agenda/MultipleSelectActions/ConfirmMultiple.js